import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';

/**
 * What an edit does to what the customer owes, said as a change rather than as a price.
 *
 * <p>On an alteration every figure on this step is a <b>difference</b>: the booking is paid for, and
 * a sailing's full fare is a number the customer is not being asked for. Showing it read as a second
 * charge — the whole trip again, on a screen whose only purpose is to move it.</p>
 *
 * <p>Signed both ways, because an unsigned "$20.00" cannot tell a refund from a surcharge, and the
 * app's own `formatPriceDisplay` only signs the negative half. The sign is also what carries the
 * meaning on its own — these figures need no caption above them, and one saying "Change" over a
 * number already written as a change said it twice.</p>
 *
 * <p>Zero is a figure like the rest — `$0.00`, in the same type, in the same place. It was a phrase
 * ("Same price"), which is two words where its neighbours have a number: it wrapped in a fare cell,
 * it was the widest thing in the day rail, and it made the one sailing that costs nothing extra look
 * like the odd one out rather than the cheapest. The decimals stay so the column lines up.</p>
 */
export const formatFareChange = (amount: number): string => {
	const money = formatPriceDisplay(Math.abs(amount), false);
	if (money === '') {
		return '';
	}
	if (Math.abs(amount) < 0.005) {
		return money;
	}
	return amount > 0 ? `+${money}` : `-${money}`;
};
